import type { SVGProps } from 'react';

export function Collaboration({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* person A */}
      <circle cx="110" cy="130" r="30" />
      <path d="M70 260 v-50 a40 40 0 0 1 80 0 v50" />
      {/* person B */}
      <circle cx="230" cy="110" r="28" fill="#E7FF4D" stroke="currentColor" />
      <path d="M192 260 v-60 a38 38 0 0 1 76 0 v60" fill="#E7FF4D" stroke="currentColor" />
      {/* person C */}
      <circle cx="330" cy="145" r="26" />
      <path d="M295 265 v-50 a35 35 0 0 1 70 0 v50" />
      {/* shared doc */}
      <rect x="140" y="290" width="120" height="70" rx="2" />
      <line x1="155" y1="310" x2="245" y2="310" />
      <line x1="155" y1="325" x2="220" y2="325" />
      <line x1="155" y1="340" x2="235" y2="340" />
      {/* pointer arrows */}
      <path d="M180 275 l-30 15" strokeDasharray="4 4" />
      <path d="M220 275 l0 15" strokeDasharray="4 4" />
      <path d="M260 275 l30 15" strokeDasharray="4 4" />
    </svg>
  );
}
